var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { renderStackedBarCells } from '@web/components/layout/RechartsItems/StackedBarCells';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { COLLABORATIVE_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { ComparisonPeriod, getCollaborativeTimeAppsTab, navigateChartPeriodBarClick } from '@web/utility/chartNavigation';
import { formatChartDayPeriodAxisLabel, formatCollaborativeTimeYAxisSeconds, getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { PeerTypeEnum } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { formatDuration, getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var PEER_TYPE_TO_CONFIG_KEY = (_a = {},
    _a[PeerTypeEnum.TEAM_INTERNAL] = 'team',
    _a[PeerTypeEnum.OTHER_TEAMS] = 'crossTeam',
    _a[PeerTypeEnum.EXTERNAL] = 'external',
    _a[PeerTypeEnum.MANAGER] = 'external',
    _a);
var EMPTY_PEER_STATS = {
    meetings: 0,
    chats: 0,
    gmails: 0,
    prevMeetings: 0,
    prevChats: 0,
    prevGmails: 0
};
var COLLABORATIVE_TIME_SERIES_KEYS = [
    'teamMeetings',
    'teamChats',
    'teamGmails',
    'crossTeamMeetings',
    'crossTeamChats',
    'crossTeamGmails',
    'externalMeetings',
    'externalChats',
    'externalGmails'
];
var COLLABORATIVE_TIME_PEER_TYPE_TO_DATA_KEY_PREFIX = (_b = {},
    _b[PeerTypeEnum.TEAM_INTERNAL] = 'team',
    _b[PeerTypeEnum.OTHER_TEAMS] = 'crossTeam',
    _b[PeerTypeEnum.EXTERNAL] = 'external',
    _b[PeerTypeEnum.MANAGER] = 'external',
    _b);
var getCollaborativeTimeSeriesKey = function (peerType, channel) {
    var prefix = COLLABORATIVE_TIME_PEER_TYPE_TO_DATA_KEY_PREFIX[peerType];
    var channelKey = channel.charAt(0).toUpperCase() + channel.slice(1);
    return "".concat(prefix).concat(channelKey);
};
var COLLABORATIVE_GMAIL_STRIPE_PATTERN_ID = {
    team: "".concat(InsightTypeEnum.collaborativeTime, "_teamGmails"),
    crossTeam: "".concat(InsightTypeEnum.collaborativeTime, "_crossTeamGmails"),
    external: "".concat(InsightTypeEnum.collaborativeTime, "_externalGmails")
};
var COLLABORATIVE_GMAIL_STRIPE_ENTRIES = [
    {
        patternId: COLLABORATIVE_GMAIL_STRIPE_PATTERN_ID.team,
        chartColor: COLLABORATIVE_CONFIG.team.gmails.chartColor
    },
    {
        patternId: COLLABORATIVE_GMAIL_STRIPE_PATTERN_ID.crossTeam,
        chartColor: COLLABORATIVE_CONFIG.crossTeam.gmails.chartColor
    },
    {
        patternId: COLLABORATIVE_GMAIL_STRIPE_PATTERN_ID.external,
        chartColor: COLLABORATIVE_CONFIG.external.gmails.chartColor
    }
];
var COLLABORATIVE_CHART_DATA_KEY_TO_TRANSLATION = {
    teamMeetings: COLLABORATIVE_CONFIG.team.meetings.translationKey,
    teamChats: COLLABORATIVE_CONFIG.team.chats.translationKey,
    teamGmails: COLLABORATIVE_CONFIG.team.gmails.translationKey,
    crossTeamMeetings: COLLABORATIVE_CONFIG.crossTeam.meetings.translationKey,
    crossTeamChats: COLLABORATIVE_CONFIG.crossTeam.chats.translationKey,
    crossTeamGmails: COLLABORATIVE_CONFIG.crossTeam.gmails.translationKey,
    externalMeetings: COLLABORATIVE_CONFIG.external.meetings.translationKey,
    externalChats: COLLABORATIVE_CONFIG.external.chats.translationKey,
    externalGmails: COLLABORATIVE_CONFIG.external.gmails.translationKey
};
var isCollaborativeChartDataKey = function (dataKey) {
    return dataKey in COLLABORATIVE_CHART_DATA_KEY_TO_TRANSLATION;
};
var createLegendItemsForPeerType = function (peerType, totals) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var peerData = (_a = totals[peerType]) !== null && _a !== void 0 ? _a : EMPTY_PEER_STATS;
    return [
        {
            key: 'meetings',
            currentValue: (_b = peerData.meetings) !== null && _b !== void 0 ? _b : 0,
            prevValue: (_c = peerData.prevMeetings) !== null && _c !== void 0 ? _c : 0,
            diffValue: peerData.diffMeetings,
            teamAverage: (_d = peerData.teamAvgMeetings) !== null && _d !== void 0 ? _d : undefined
        },
        {
            key: 'chats',
            currentValue: (_e = peerData.chats) !== null && _e !== void 0 ? _e : 0,
            prevValue: (_f = peerData.prevChats) !== null && _f !== void 0 ? _f : 0,
            diffValue: peerData.diffChats,
            teamAverage: (_g = peerData.teamAvgChats) !== null && _g !== void 0 ? _g : undefined
        },
        {
            key: 'gmails',
            currentValue: (_h = peerData.gmails) !== null && _h !== void 0 ? _h : 0,
            prevValue: (_j = peerData.prevGmails) !== null && _j !== void 0 ? _j : 0,
            diffValue: peerData.diffGmails,
            teamAverage: (_k = peerData.teamAvgGmails) !== null && _k !== void 0 ? _k : undefined
        }
    ];
};
var getPeerPeriodStats = function (period, peerType) { var _a; return (_a = period[peerType]) !== null && _a !== void 0 ? _a : EMPTY_PEER_STATS; };
var createChartData = function (periods) {
    return periods.map(function (period) { return ({
        period: period.period,
        teamMeetings: getPeerPeriodStats(period, PeerTypeEnum.TEAM_INTERNAL)
            .meetings,
        teamChats: getPeerPeriodStats(period, PeerTypeEnum.TEAM_INTERNAL).chats,
        teamGmails: getPeerPeriodStats(period, PeerTypeEnum.TEAM_INTERNAL).gmails,
        crossTeamMeetings: getPeerPeriodStats(period, PeerTypeEnum.OTHER_TEAMS)
            .meetings,
        crossTeamChats: getPeerPeriodStats(period, PeerTypeEnum.OTHER_TEAMS).chats,
        crossTeamGmails: getPeerPeriodStats(period, PeerTypeEnum.OTHER_TEAMS)
            .gmails,
        externalMeetings: getPeerPeriodStats(period, PeerTypeEnum.EXTERNAL)
            .meetings,
        externalChats: getPeerPeriodStats(period, PeerTypeEnum.EXTERNAL).chats,
        externalGmails: getPeerPeriodStats(period, PeerTypeEnum.EXTERNAL).gmails
    }); });
};
export var ByCollaborativeTime = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _b = trpc.communicationByCollaborativeTime.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), collaborativeTimeData = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !collaborativeTimeData) {
        return _jsx(Loading, {});
    }
    var interval = getInterval(dateFrom, dateTo);
    var chartData = createChartData(collaborativeTimeData.periods);
    var chartDataForNavigation = chartData;
    var handleBarClick = function (dataKey, barData, fallbackIndex) {
        navigateChartPeriodBarClick({
            chartData: chartDataForNavigation,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: ComparisonPeriod.Current,
            destination: { kind: 'apps', tab: getCollaborativeTimeAppsTab(dataKey) },
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var collaborativeBarNavigationProps = function (dataKey) { return ({
        onClick: function (barData, index) {
            return handleBarClick(dataKey, barData, index);
        },
        style: { cursor: 'pointer' }
    }); };
    var _c = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: 3
    }), barGap = _c.barGap, barSize = _c.barSize, periodXAxis = _c.periodXAxis, periodBarChartMargin = _c.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var legendPeerTypes = [
        PeerTypeEnum.TEAM_INTERNAL,
        PeerTypeEnum.OTHER_TEAMS,
        PeerTypeEnum.EXTERNAL
    ];
    var legendItems = legendPeerTypes.map(function (type) { return ({
        type: type,
        items: createLegendItemsForPeerType(type, collaborativeTimeData.totals)
    }); });
    var collaborativeTimeLabelPrefix = 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.collaborativeTime';
    var renderCollaborativeTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: [
            'teamMeetings',
            'teamChats',
            'teamGmails',
            'crossTeamMeetings',
            'crossTeamChats',
            'crossTeamGmails',
            'externalMeetings',
            'externalChats',
            'externalGmails'
        ], separatorAfterDataKeys: ['teamGmails', 'crossTeamGmails'], seriesLabelFormatter: function (dataKey) {
            return isCollaborativeChartDataKey(dataKey)
                ? t("".concat(collaborativeTimeLabelPrefix, ".").concat(COLLABORATIVE_CHART_DATA_KEY_TO_TRANSLATION[dataKey]))
                : dataKey;
        }, formatValue: function (value) { return formatDuration(value, 'seconds'); }, stripeSwatchColors: {
            teamGmails: COLLABORATIVE_CONFIG.team.gmails.chartColor,
            crossTeamGmails: COLLABORATIVE_CONFIG.crossTeam.gmails.chartColor,
            externalGmails: COLLABORATIVE_CONFIG.external.gmails.chartColor
        } }), chartData.length);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.collaborativeTime'), description: t('widgetTitleDescriptions.communication.collaborativeTime'), insightType: InsightTypeEnum.collaborativeTime, insightsData: collaborativeTimeData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.collaborativeTime'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, collaborativeTimeData.periods.map(function (period) {
                                    var _a;
                                    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
                                    return (_a = {},
                                        _a[t('filters.period')] = period.period,
                                        _a.TeamMeetings = formatDuration((_b = getPeerPeriodStats(period, PeerTypeEnum.TEAM_INTERNAL)
                                            .meetings) !== null && _b !== void 0 ? _b : 0, 'seconds'),
                                        _a.TeamChats = formatDuration((_c = getPeerPeriodStats(period, PeerTypeEnum.TEAM_INTERNAL)
                                            .chats) !== null && _c !== void 0 ? _c : 0, 'seconds'),
                                        _a.TeamGmail = formatDuration((_d = getPeerPeriodStats(period, PeerTypeEnum.TEAM_INTERNAL)
                                            .gmails) !== null && _d !== void 0 ? _d : 0, 'seconds'),
                                        _a.CrossTeamMeetings = formatDuration((_e = getPeerPeriodStats(period, PeerTypeEnum.OTHER_TEAMS)
                                            .meetings) !== null && _e !== void 0 ? _e : 0, 'seconds'),
                                        _a.CrossTeamChats = formatDuration((_f = getPeerPeriodStats(period, PeerTypeEnum.OTHER_TEAMS).chats) !== null && _f !== void 0 ? _f : 0, 'seconds'),
                                        _a.CrossTeamGmail = formatDuration((_g = getPeerPeriodStats(period, PeerTypeEnum.OTHER_TEAMS).gmails) !== null && _g !== void 0 ? _g : 0, 'seconds'),
                                        _a.ExternalMeetings = formatDuration((_h = getPeerPeriodStats(period, PeerTypeEnum.EXTERNAL).meetings) !== null && _h !== void 0 ? _h : 0, 'seconds'),
                                        _a.ExternalChats = formatDuration((_j = getPeerPeriodStats(period, PeerTypeEnum.EXTERNAL).chats) !== null && _j !== void 0 ? _j : 0, 'seconds'),
                                        _a.ExternalGmail = formatDuration((_k = getPeerPeriodStats(period, PeerTypeEnum.EXTERNAL).gmails) !== null && _k !== void 0 ? _k : 0, 'seconds'),
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(collaborativeTimeData) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: COLLABORATIVE_TIME_SERIES_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "flex gap-8 lg:gap-8 mb-6 p-4 ml-2 rounded-lg justify-straight flex-wrap" }, { children: legendItems.map(function (_a) {
                                    var type = _a.type, items = _a.items;
                                    return (_jsx("div", __assign({ className: "flex flex-col gap-2 lg:gap-4" }, { children: items.map(function (_a) {
                                            var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                            var barConfig = COLLABORATIVE_CONFIG[PEER_TYPE_TO_CONFIG_KEY[type]][key];
                                            var seriesKey = getCollaborativeTimeSeriesKey(type, key);
                                            return (_jsx(LegendItem, { color: barConfig.color, label: t("".concat(collaborativeTimeLabelPrefix, ".").concat(barConfig.translationKey)), currentValueClassName: "text-sm font-semibold", currentValue: formatDuration(currentValue, 'seconds'), diffValue: diffValue, teamAverage: teamAverage, arrowColor: TablesDiffColorsConfig.GREEN, stripeChartColor: 'striped' in barConfig
                                                    ? barConfig.chartColor
                                                    : undefined, onClick: function () { return toggleSeries(seriesKey); }, isHidden: !isSeriesVisible(seriesKey) }, "".concat(type, "-").concat(key)));
                                        }) }), type));
                                }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [rechartsDiagonalStripePatternDefs(COLLABORATIVE_GMAIL_STRIPE_ENTRIES), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, interval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, tickFormatter: function (v) {
                                                    return formatCollaborativeTimeYAxisSeconds(Number(v));
                                                } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderCollaborativeTooltip }), _jsx(Bar, __assign({ dataKey: "teamMeetings", fill: COLLABORATIVE_CONFIG.team.meetings.chartColor, stackId: "team", hide: !isSeriesVisible('teamMeetings') }, collaborativeBarNavigationProps('teamMeetings'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'teamMeetings',
                                                        'teamChats',
                                                        'teamGmails'
                                                    ],
                                                    segmentIndex: 0,
                                                    keyPrefix: 'team-meetings'
                                                }) })), _jsx(Bar, __assign({ dataKey: "teamChats", fill: COLLABORATIVE_CONFIG.team.chats.chartColor, stackId: "team", hide: !isSeriesVisible('teamChats') }, collaborativeBarNavigationProps('teamChats'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'teamMeetings',
                                                        'teamChats',
                                                        'teamGmails'
                                                    ],
                                                    segmentIndex: 1,
                                                    keyPrefix: 'team-chats'
                                                }) })), _jsx(Bar, __assign({ dataKey: "teamGmails", fill: rechartsDiagonalStripeFillUrl(COLLABORATIVE_GMAIL_STRIPE_PATTERN_ID.team), stackId: "team", hide: !isSeriesVisible('teamGmails') }, collaborativeBarNavigationProps('teamGmails'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'teamMeetings',
                                                        'teamChats',
                                                        'teamGmails'
                                                    ],
                                                    segmentIndex: 2,
                                                    keyPrefix: 'team-gmails'
                                                }) })), _jsx(Bar, __assign({ dataKey: "crossTeamMeetings", fill: COLLABORATIVE_CONFIG.crossTeam.meetings.chartColor, stackId: "crossTeam", hide: !isSeriesVisible('crossTeamMeetings') }, collaborativeBarNavigationProps('crossTeamMeetings'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'crossTeamMeetings',
                                                        'crossTeamChats',
                                                        'crossTeamGmails'
                                                    ],
                                                    segmentIndex: 0,
                                                    keyPrefix: 'cross-team-meetings'
                                                }) })), _jsx(Bar, __assign({ dataKey: "crossTeamChats", fill: COLLABORATIVE_CONFIG.crossTeam.chats.chartColor, stackId: "crossTeam", hide: !isSeriesVisible('crossTeamChats') }, collaborativeBarNavigationProps('crossTeamChats'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'crossTeamMeetings',
                                                        'crossTeamChats',
                                                        'crossTeamGmails'
                                                    ],
                                                    segmentIndex: 1,
                                                    keyPrefix: 'cross-team-chats'
                                                }) })), _jsx(Bar, __assign({ dataKey: "crossTeamGmails", fill: rechartsDiagonalStripeFillUrl(COLLABORATIVE_GMAIL_STRIPE_PATTERN_ID.crossTeam), stackId: "crossTeam", hide: !isSeriesVisible('crossTeamGmails') }, collaborativeBarNavigationProps('crossTeamGmails'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'crossTeamMeetings',
                                                        'crossTeamChats',
                                                        'crossTeamGmails'
                                                    ],
                                                    segmentIndex: 2,
                                                    keyPrefix: 'cross-team-gmails'
                                                }) })), _jsx(Bar, __assign({ dataKey: "externalMeetings", fill: COLLABORATIVE_CONFIG.external.meetings.chartColor, stackId: "external", hide: !isSeriesVisible('externalMeetings') }, collaborativeBarNavigationProps('externalMeetings'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'externalMeetings',
                                                        'externalChats',
                                                        'externalGmails'
                                                    ],
                                                    segmentIndex: 0,
                                                    keyPrefix: 'external-meetings'
                                                }) })), _jsx(Bar, __assign({ dataKey: "externalChats", fill: COLLABORATIVE_CONFIG.external.chats.chartColor, stackId: "external", hide: !isSeriesVisible('externalChats') }, collaborativeBarNavigationProps('externalChats'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'externalMeetings',
                                                        'externalChats',
                                                        'externalGmails'
                                                    ],
                                                    segmentIndex: 1,
                                                    keyPrefix: 'external-chats'
                                                }) })), _jsx(Bar, __assign({ dataKey: "externalGmails", fill: rechartsDiagonalStripeFillUrl(COLLABORATIVE_GMAIL_STRIPE_PATTERN_ID.external), stackId: "external", hide: !isSeriesVisible('externalGmails') }, collaborativeBarNavigationProps('externalGmails'), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: [
                                                        'externalMeetings',
                                                        'externalChats',
                                                        'externalGmails'
                                                    ],
                                                    segmentIndex: 2,
                                                    keyPrefix: 'external-gmails'
                                                }) }))] })) })) }))] })));
                } }))] })));
};
